import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import RenderElement from "../../../helpers/RenderElement";
import { SideEditOptions } from "../../../types/elements";
import ElementColorImage from "../Common/ElementColorImage";
import RepeatGroup from "../Common/RepeatGroup";
import RepeatItem from "../Common/RepeatItem";
const LogosSimple = ({ elementId, elementProps, editable }) => {
    const renderElement = RenderElement.setProps(elementProps);
    const repeatConfig = [
        {
            type: SideEditOptions.Select,
            config: {
                key: "items-desktop",
                label: "Aantal items op desktop",
                defaultValue: "lg:grid-cols-3",
                open: false,
                selectOptions: [
                    {
                        value: "lg:grid-cols-1",
                        label: "1",
                    },
                    {
                        value: "lg:grid-cols-2",
                        label: "2",
                    },
                    {
                        value: "lg:grid-cols-3",
                        label: "3",
                    },
                    {
                        value: "lg:grid-cols-4",
                        label: "4",
                    },
                    {
                        value: "lg:grid-cols-5",
                        label: "5",
                    },
                    {
                        value: "lg:grid-cols-6",
                        label: "6",
                    },
                ],
            },
        },
        {
            type: SideEditOptions.Select,
            config: {
                key: "items-tablet",
                label: "Aantal items op tablet",
                defaultValue: "md:grid-cols-2",
                open: false,
                selectOptions: [
                    {
                        value: "md:grid-cols-1",
                        label: "1",
                    },
                    {
                        value: "md:grid-cols-2",
                        label: "2",
                    },
                    {
                        value: "md:grid-cols-3",
                        label: "3",
                    },
                    {
                        value: "md:grid-cols-4",
                        label: "4",
                    },
                ],
            },
        },
        {
            type: SideEditOptions.Select,
            config: {
                key: "items-mobile",
                label: "Aantal items op mobiel",
                defaultValue: "grid-cols-1",
                open: false,
                selectOptions: [
                    {
                        value: "grid-cols-1",
                        label: "1",
                    },
                    {
                        value: "grid-cols-2",
                        label: "2",
                    },
                    {
                        value: "grid-cols-3",
                        label: "3",
                    },
                ],
            },
        },
    ];
    return (_jsx(ElementColorImage, { editorKey: "container-1", renderElement: renderElement, elementId: elementId, className: "p-8", children: _jsx("div", { className: "mx-auto max-w-7xl px-6 py-12 lg:px-8", children: _jsx(RepeatItem, { className: `grid gap-8 ${renderElement.renderProp("logos-repeat", "items-mobile")?.value ||
                    "grid-cols-2"} ${renderElement.renderProp("logos-repeat", "items-tablet")?.value ||
                    "md:grid-cols-2"} ${renderElement.renderProp("logos-repeat", "items-desktop")?.value ||
                    "lg:grid-cols-3"}`, repeatId: "logos-repeat", "editor-key": "logos-repeat", elementProps: elementProps, elementId: elementId, create: true, editable: editable, ...renderElement.renderAttributeOptions(repeatConfig, "logos-repeat"), children: _jsx(_Fragment, { children: ["default", ...(elementProps?.["logos-repeat"]?.items || [])].map((repeatKey) => (_jsx(RepeatGroup, { index: repeatKey, group: "logos-repeat", editable: editable, elementId: elementId, children: _jsx("div", { className: "col-span-1 flex justify-center md:col-span-2 lg:col-span-1", children: _jsx("img", { "editor-key": `logos-repeat-${repeatKey}-logo`, ...renderElement.renderClassName(`logos-repeat-${repeatKey}-logo`, "h-12"), ...renderElement.renderImage(`logos-repeat-${repeatKey}-logo`, {
                                    src: "https://tailwindui.com/img/logos/tuple-logo-gray-400.svg",
                                }) }) }, repeatKey) }))) }) }) }) }));
};
export default LogosSimple;
//# sourceMappingURL=LogosSimple.js.map